import * as React from 'react'
import { FieldProps, Field } from 'formik'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'

import { TextAreaField } from '@espoon-voltti/react-components/elements/form'
import { fieldState, ErrorMessage } from '../formik-util'
import { InputProps } from './types'

export const FormTextArea = (p: InputProps & { rows?: number }) => (
  <Field name={p.name}>
    {({ field, form }: FieldProps) => (
      <TextAreaField
        required={p.required}
        dataQa={p.dataQa}
        disabled={p.disabled}
        {...field}
        label={p.label}
        state={fieldState(field.name, form)}
        message={<ErrorMessage name={field.name} />}
        placeholder={p.placeholder}
        rows={pipe(
          O.fromNullable(p.rows),
          O.getOrElse(() => 5)
        )}
        maxLength={p.maxLength}
      />
    )}
  </Field>
)
